module.exports = __webpack_public_path__ + "img/R8805-IB.43af84db.jpg";